module.exports = __webpack_public_path__ + "media/images/house-5b6146b301fd6bc86da21c575d386599.png";